import { render, staticRenderFns } from "./CountryDistribution.vue?vue&type=template&id=331c2060&scoped=true&"
import script from "./CountryDistribution.vue?vue&type=script&lang=ts&"
export * from "./CountryDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c2060",
  null
  
)

export default component.exports